import { DataForSearchTour } from 'entities/tour/models/search-tour'

import { HotelSearch } from 'shared/api/tours/search'

export const getDataForSearchTour = (
  dataForSearchTour?: DataForSearchTour,
): HotelSearch => {
  return {
    departure_city_id: dataForSearchTour?.departure?.id,
    destination_country_id: dataForSearchTour?.country?.id,
    destination_cities_ids: dataForSearchTour?.resorts?.map((resort) =>
      String(resort.id),
    ),
    checkin_date: dataForSearchTour?.flight?.startDay,
    adult: dataForSearchTour?.passengers?.adults,
    child: dataForSearchTour?.passengers?.children,
    ages: dataForSearchTour?.passengers?.childrenAges?.map(String),
    nights: dataForSearchTour?.duration,
    is_flexible_date: dataForSearchTour?.is_flexible_date,
    is_flexible_nights: dataForSearchTour?.is_flexible_nights,
  }
}
